import { useParams } from 'react-router-dom';

import { useGetTelehealthSessionInfo } from '../../hooks';
import { Page } from './Page';
import { IntroRoomContentWrapper } from './page-content/IntroRoomContentWrapper';

export function PageWrapper() {
  const { providerShortId, patientShortId } = useParams();
  useGetTelehealthSessionInfo(providerShortId, patientShortId);

  return <Page pageContentComponent={IntroRoomContentWrapper} />;
}
